import { TrendingEndpoint } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  TrendingEndpoint,
  React
};